/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRecurringDepositAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6.5 2.8V2h2v.8h2.857v2H8.5V7h1.25C11.479 7 13 8.324 13 10.1c0 .065-.002.128-.006.192A7.015 7.015 0 0 0 9.12 13.2H8.5v.8h-2v-.8H3v-2h3.5V9H5.25C3.521 9 2 7.676 2 5.9s1.521-3.1 3.25-3.1zm0 2H5.25C4.494 4.8 4 5.356 4 5.9S4.494 7 5.25 7H6.5zm2 4.2v2.2h1.25c.756 0 1.25-.556 1.25-1.1S10.507 9 9.75 9zm3.5 8a3 3 0 1 1 6 0v.586l-1.293-1.293-1.414 1.414L19 21.414l3.707-3.707-1.414-1.414L20 17.586V17a5 5 0 1 0-5 5v-2a3 3 0 0 1-3-3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRecurringDepositAlt as RecurringDepositAlt };
